/**
 * Кол-во столбцов по умолчанию
 */
export const defaultNumberCols = 90;

/**
 * Минимальная высота колонки (в процентах)
 */
export const minHeight = 10; // %